import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSentQReply } from '../ccf-app-space/ccf-app-space.slice';
import {
  activeContactSelector,
  getActiveInteractionID,
  getContactElevationDetails,
  getGeneratedEmailResponse,
  getIsCopilotEmailResponseGenerated,
  setGeneratedEmailResponse,
  updateAppSpaceTab,
  updateEmailWithApproval,
  updateTwitterAgentReply,
  getAttachments,
  removeAttachment
} from '../ccf-inbox/ccf-inbox.slice';
import { TransitionGroup } from 'react-transition-group';
import styles from './ccf-digital-email-template.module.scss';
import { AppSpace } from '../../enums/app-space-tabs';
import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfCopilotSuggestionIcon,
  CcfDeboucedInput,
  CcfEmailJpgIcon,
  CcfEmailPdfIcon,
  CcfFileUploadIcon,
  CcfFlashIcon,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { KeyboardArrowDown, Send, Search } from '@mui/icons-material';
import CcfEmailProgressBar from './ccf-email-progress-bar';
import {
  ClickAwayListener,
  Divider,
  InputAdornment,
  Slide,
  Popover,
  Button,
  Box,
} from '@mui/material';
import { useMsal } from '@azure/msal-react';
//import { copilotActionIcons } from '../ccf-app-space/ccf-copilot/ccf-copilot-icons';
import { getIsResponseInserted } from '../ccf-app-space/ccf-copilot/ccf-copilot-chat/+state/ccf-live-copilot.slice';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical';
import LexicalEditorContent from './ccf-rich-text-editor';
import { ListNode, ListItemNode } from '@lexical/list';
import { LinkNode } from '@lexical/link';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { editorTheme } from './ccf-rich-text-editor.styles';
import { getSpaceBtnCounterForCopilotEmail } from '../ccf-app-space/ccf-copilot/ccf-copilot-chat/+state/ccf-copilot.slice';
import { InlineImageNode } from './ccf-inline-image-node';
import { $generateHtmlFromNodes } from '@lexical/html';

/* eslint-disable-next-line */
export interface CcfDigitalEmailTemplateProps {
  closeEmailReplyHandler: any;
}

/**
 * Component used for Digital email Template
 * @param props - CcfDigitalEmailTemplateProps
 * @example <CcfDigitalEmailTemplate />
 * @returns
 */
export function CcfDigitalEmailTemplate(props: CcfDigitalEmailTemplateProps) {
  const { closeEmailReplyHandler } = props;
  const activecontact = useSelector(activeContactSelector);
  const activecontactId = activecontact?.id || '';
  const { accounts } = useMsal();
  const [translate] = useTranslator();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [emailList, setEmailList] = useState(Array);
  const [emailItems, setEmailItems] = useState(Array);
  const [emailCcItems, setEmailCcItems] = useState(Array);
  const [emailIBcctems, setEmailBccItems] = useState(Array);
  const [emailValue, setEmailValue] = useState('');
  const [emailCcValue, setEmailCcValue] = useState('');
  const [emailBccValue, setEmailBccValue] = useState('');
  const [emailSubject, setEmailSubject] = useState(
    activecontact?.emailSubject
      ? activecontact?.emailSubject
      : activecontact?.copilotAssist === 'Yes'
      ? 'Damaged Luggage Claim'
      : "RE: Where's my refund?"
  );
  const spaceBtnClickedCountForEmail = useSelector(
    getSpaceBtnCounterForCopilotEmail
  );
  const quickReply = useSelector(getSentQReply);
  const [editorState, setEditorState] = useState<string>('');
  const editorRef = useRef<any>(null); //Email Content
  const [EmailSendButton, setEmailSendButton] = useState(false);
  const contactElevatedDetails = useSelector(getContactElevationDetails);
  const dispatch = useDispatch();
  const activeInteractionID: string = useSelector(getActiveInteractionID) || '';
  const fileUpload = useRef<any>(null);
  const fromInputref = useRef<any>('');
  const toInputref = useRef<any>('');
  const [replyAttachmentList, setreplyAttachmentList] = useState(Array);
  const [replyWithApprovalBlock, setReplyWithApprovalBlock] = useState(false);
  const approvalDepartmentsData = [
    'Agent Training',
    'Customer Service',
    'Finance Department',
    'HR Department',
    'Knowledge Base',
    'Instagram Approvals',
    'LinkedIn Approvals',
    'Sales Department',
    'Apple Business Chat',
    'Facebook Approvals',
    'Email Approvals',
  ];
  const recentlyUsedApprovalDepartmentsData = [
    'Apple Business Chat',
    'Facebook Approvals',
    'Email Approvals',
  ];
  const [searchInput, setSearchInput] = useState('');
  const [searchedData, setSearchedData] = useState(approvalDepartmentsData);
  const isCopilotEmailResponseGenerated = useSelector(
    getIsCopilotEmailResponseGenerated
  );
  const isResponseInserted: boolean | undefined = useSelector(
    getIsResponseInserted(activecontactId)
  );
  const generatedEmailResponse: any[] =
    useSelector(getGeneratedEmailResponse) || [];
    const [selectedText, setSelectedText] = useState('');
  const [isCopilotActionMenuOpen, setIsCopilotActionMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [copilotActionUpdatedText, setCopilotActionUpdatedText] = useState('');
  const [isWebLinkInserted, setIsWebLinkInserted] = useState(false);
  const audioAttachments = useSelector(getAttachments) || [];
  const AUDIO_FILE_TYPES = ['audio/aac', 'audio/amr', 'audio/mpeg', 'audio/mp4', 'audio/ogg'];

  useEffect(() => {
    dispatch(
      setGeneratedEmailResponse([
        `Hi ${activecontact?.customer.firstName},`,
        `Thank you for reaching out to us, and I sincerely apologize for the inconvenience you experienced during your recent flight from Salt Lake City to Chicago.`,
        `I understand how frustrating and disruptive these issues can be. We aim to provide a seamless travel experience, and it's disheartening to hear that we fell short of your expectations.`,
        'To address the issue with your damaged luggage, complete the steps below:',
        '1. Obtain a reference number here: <a href="https://www.delta.com/referencenumber" target="_blank">Obtaining a reference number.</a>',
        '2. Take pictures of the damaged luggage and keep them as evidence.',
        '3. Fill out the damaged luggage claim form linked here and provide the flight number, date of travel and a description of the damage.',
        '4. Attach pictures to the claim form.',
        '5. Keep a copy for your records, Delta will get back in 7-10 business days.',
        'Thanks for your patience,',
        'Delta Customer Service',
      ])
    );
    setIsWebLinkInserted(true);
  }, [isResponseInserted]);

  useEffect(() => {
    setTimeout(() => {
      if (spaceBtnClickedCountForEmail === 3) {
        dispatch(
          setGeneratedEmailResponse([
            `Hi ${activecontact?.customer.firstName},`,
            `Thank you for reaching out to us, and I sincerely apologize for the inconvenience you experienced during your recent flight from Salt Lake City to Chicago.`,
            `I understand how frustrating and disruptive these issues can be. We aim to provide a seamless travel experience, and it's disheartening to hear that we fell short of your expectations.`,
            `To address the issue with your damaged luggage, please follow the steps below:`,
            `1. Enter this reference number into your claim - GHY38R.`,
            `2. Take pictures of the damaged luggage and keep them as evidence.`,
            `3. Fill out the damaged luggage claim form linked here and provide the flight number, date of travel, and a description of the damage.`,
            `4. Attach pictures to the claim form.`,
            '5. Keep a copy for your records, Delta will get back in 7-10 business days.',
            'Thanks for your patience,',
            'Delta Customer Service',
          ])
        );
        document.getElementById('twitterContainer')?.scroll({
          top: document.getElementById('twitterContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
      } else {
        document.getElementById('twitterContainer')?.scroll({
          top: document.getElementById('twitterContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
      }
    }, 4000);
  }, [spaceBtnClickedCountForEmail]);

  useEffect(() => {
    if (
      activecontact?.isElevated &&
      activecontact?.copilotAssist === 'Yes' &&
      activecontact?.copilotSource === 'JSON'
    ) {
      setEmailSubject(
        contactElevatedDetails.get('email')?.emailTemplate?.subject
      );
    }
    setTimeout(() => {
      document.getElementById('twitterContainer')?.scroll({
        top: document.getElementById('twitterContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
    }, 1000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('agent_webChatContainer')?.scroll({
        top: document.getElementById('agent_webChatContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
      document.getElementById('twitterContainer')?.scroll({
        top: document.getElementById('twitterContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
    }, 300);
    //setEditorState((prev) => prev.replace(selectedText, htmlEmailContent));
  }, [isCopilotEmailResponseGenerated]);

  useEffect(() => {
    if (quickReply && activecontact?.channel === 'Email' && editorRef.current) {
      const userFirstName = activecontact?.customer.firstName;
      const agentFirstName =
        loginCredentialsArray[0].charAt(0).toUpperCase() +
        loginCredentialsArray[0].slice(1).toLowerCase();
      const agentSurName =
        loginCredentialsArray[1].charAt(0).toUpperCase() +
        loginCredentialsArray[1].slice(1).toLowerCase();
      dispatch(
        setGeneratedEmailResponse([
          'Hi ' + userFirstName + ',',
          quickReply,
          'Thanks,',
          agentFirstName + agentSurName + ' ',
        ])
      );
      setEmailSendButton(true);
    }
  }, [quickReply]);

  /**
   * Function to open quick reply
   * @param event -any
   * @example openQuickReply
   */
  const openQuickReply = (event: any) => {
    dispatch(updateAppSpaceTab({ tab: AppSpace.QUICK_REPLY }));
  };

  /**
   * Function to display Cc field
   * @param event -any
   * @example displayCc
   */
  const displayCc = () => {
    setShowCc(true);
  };

  /**
   * Function to hide cc field
   * @param event -any
   * @example  hideCcHandler
   */
  const hideCcHandler = () => {
    setShowCc(false);
  };

  /**
   * Function to display Bcc field
   * @param event -any
   * @example displayBcc
   */
  const displayBcc = () => {
    setShowBcc(true);
  };

  /**
   * Function to hide Bcc field
   * @param event -any
   * @example  hideCcHandler
   */
  const hideBccHandler = () => {
    setShowBcc(false);
  };

  /**
   * Function to handle key down event
   * @param event -any
   * @example handleKeyDown
   */
  const handleKeyDown = (evt: any) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault();

      const value = emailValue.trim();
      const ccValue = emailCcValue.trim();
      const bccValue = emailBccValue.trim();

      if (value && isValid(value, 'to')) {
        setEmailItems([...emailItems, emailValue]);
        setEmailList([...emailList, emailValue]);
        // setEmailValue('');
      } else if (ccValue && isValid(ccValue, 'cc')) {
        setEmailCcItems([...emailCcItems, emailCcValue]);
        setEmailList([...emailList, emailCcValue]);
        // setEmailCcValue('');
      } else if (bccValue && isValid(bccValue, 'bcc')) {
        setEmailBccItems([...emailIBcctems, emailBccValue]);
        setEmailList([...emailList, emailBccValue]);
        // setEmailBccValue('');
      }
    }
  };

  /**
   * Function to check if email is valid
   * @param event -any
   * @example isValid
   */
  const isValid = (email: any, emailType: string) => {
    let error = null;

    if (isInList(email, emailType)) {
      error = `${email}` + translate('hasalreadybeenadded.');
    }

    if (!isEmail(email)) {
      error = `${email}` + translate('isnotavalidemailaddress.');
    }

    return true;
  };

  /**
   * Function to check if email is in list
   * @param event -any
   * @example isInList
   */
  const isInList = (email: any, emailType: string) => {
    return emailList.includes(email);
  };

  /**
   * Function to check if it is an email
   * @param event -any
   * @example isEmail
   */
  const isEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  /**
   * Function to format editor content to HTML
   * @example formatEditorContentToHTML()
   */
  const formatEditorContentToHTML = (editorState: any,editor: any): string => {
    let formattedText = '';
    editorState.read(() => {
      formattedText = $generateHtmlFromNodes(editor);
    });
    return formattedText;
  };
  /**
   * Function to handle email reply
   * @example emailReplyHandler()
   */
  const emailReplyHandler = () => {
    if (!editorRef?.current) return;

    const editorState = editorRef.current.getEditorState();
    const htmlContent = formatEditorContentToHTML(editorState,editorRef.current);

    if (activecontact?.customer?.replywithApproval === 'Yes') {
      setSearchedData(approvalDepartmentsData);
      setSearchInput('');
      if (!replyWithApprovalBlock) {
        setReplyWithApprovalBlock(true);
      }
    } else {
      dispatchEmailReplyMessage(htmlContent);
      editorRef.current.update(() => {
        const root = $getRoot();
        root.clear();
      });
      setEmailSendButton(false);
      closeEmailReplyHandler();
    }
  };

  /**
   * Function to select Approval department
   * @example selectRequestApprovalDepartment()
   */
  const selectRequestApprovalDepartment = (dep: any) => {
    console.log(dep);
    if (dep === 'Email Approvals') {
      let emailContent = '';
      if (editorRef.current) {
        editorRef.current.update(() => {
          emailContent = $getRoot().getTextContent();
        });
      }
      dispatchEmailReplyMessage(emailContent);
      dispatch(updateEmailWithApproval(true));
      //editorRef.current.getContent('');
      setEmailSendButton(false);
      setEmailSendButton((state) => {
        return state;
      });
      closeEmailReplyHandler();
    }
    setReplyWithApprovalBlock(false);
    setReplyWithApprovalBlock((state) => {
      return state;
    });
  };

  /**
   * Function to Filter out data based on search value
   * @param searchText -string
   * @example filteredDataBasedOnSearch('Email Approvals)
   */
  const filteredDataBasedOnSearch = (searchText: string) => {
    const value = searchText;
    console.log(value);
    const filterOnSearch = approvalDepartmentsData.filter((data: any) =>
      data.toLowerCase().includes(value)
    );
    setSearchedData(filterOnSearch);
    console.log(searchedData);
  };

  /**
   * Search the value based n every input value
   * @param event - React.ChangeEvent
   * @example - onSearchInputChange(event)
   */
  const onSearchInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    e.preventDefault();
    filteredDataBasedOnSearch(e.target.value.toLowerCase());
    setReplyWithApprovalBlock(true);
    setReplyWithApprovalBlock((state) => {
      return state;
    });
  };

  /**
   * close Reply Approval block when clicked outside
   * @param event - React.ChangeEvent
   * @example - handleClickOutside()
   */
  const handleClickOutside = () => {
    setReplyWithApprovalBlock(false);
    setReplyWithApprovalBlock((state) => {
      return state;
    });
  };

  /**Function to render request approval block
   * @example - renderRequestApprovalBlock()
   */
  const renderRequestApprovalBlock = () => {
    return (
      <ClickAwayListener onClickAway={handleClickOutside}>
        <div className={styles.replyWithApprovalBlock}>
          <ul
            className={`${styles.unavailableStatusGrp} ${styles.approvalDepartmentGrp}`}
          >
            {searchedData.map((dep: any) => (
              <li
                className={styles.unavailableStatus}
                value={dep}
                onClick={() => selectRequestApprovalDepartment(dep)}
              >
                <CcfTypography className={styles.departmentText}>
                  {dep}
                </CcfTypography>
              </li>
            ))}
          </ul>
          <div className={styles.searchBox}>
            <CcfDeboucedInput
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search htmlColor="grey" />
                  </InputAdornment>
                ),
                classes: { adornedStart: styles.searchInputBox },
              }}
              onChange={onSearchInputChange}
              classes={{
                root: styles.searchInput,
              }}
              placeholder="Search for..."
              variant="outlined"
              fullWidth
              delay={1000}
              value={searchInput}
            />
          </div>
          <div style={{ marginTop: '20px' }}>
            <Divider />
          </div>
          <ul className={styles.unavailableStatusGrp}>
            <li className={styles.unavailableStatus}>
              <CcfTypography
                className={styles.departmentText}
                style={{ color: '#C3C5C7' }}
              >
                <b>{translate('recentlyUsed')}</b>
              </CcfTypography>
            </li>
            {recentlyUsedApprovalDepartmentsData.map((dep: any) => (
              <li
                className={styles.unavailableStatus}
                value={dep}
                onClick={() => selectRequestApprovalDepartment(dep)}
              >
                <CcfTypography className={styles.departmentText}>
                  {dep}
                </CcfTypography>
              </li>
            ))}
          </ul>
        </div>
      </ClickAwayListener>
    );
  };

  /**
   * Function to get file info of attchment being uploaded
   * @example getFileInfo()
   */
  const getFileInfo = () => {
    // setProgress(0);
    const data = new FormData();
    data.append('file', fileUpload.current.files);
    const attachmentCopy = [];
    for (const item of fileUpload.current.files) {
      attachmentCopy.push({ name: item.name, progress: 0 });
    }
    setreplyAttachmentList([...replyAttachmentList, ...attachmentCopy]);
    setreplyAttachmentList((state) => {
      return state;
    });
    fileUpload.current.value = '';
  };

  /**
   * Function to dispatch email reply message
   * @param message - string
   * @example dispatchEmailReplyMessage(quickReply)
   */
  const dispatchEmailReplyMessage = (message: string) => {
    const newReplyAttachmentList: any = [];
    replyAttachmentList.map((item: any) => {
      newReplyAttachmentList.push(item.name);
    });
    audioAttachments.filter(file=>AUDIO_FILE_TYPES.includes(file.fileType)).forEach((file: any) => { newReplyAttachmentList.push(file)});
    audioAttachments.filter(file=>AUDIO_FILE_TYPES.includes(file.fileType)).forEach((file: any) => { dispatch(removeAttachment(file.id))});
    const replyMessage = {
      messageId: new Date().toString(),
      postId: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
      isOwn: true,
      isAgentReply: true,
      createdAt: 'Mon, July 28 12:02 PM (4 day ago)',
      messageContent: {
        payload: {
          text: message,
        },
      },
      reactionStatistics: {
        likes: 0,
      },
      authorUser: {
        firstName:
          loginCredentialsArray[0].charAt(0).toUpperCase() +
          loginCredentialsArray[0].slice(1).toLowerCase(),
        surname:
          loginCredentialsArray[1].charAt(0).toUpperCase() +
          loginCredentialsArray[1].slice(1).toLowerCase(),
        emailAddress: activecontact?.customer?.emailId,
        loginUsername: activecontact?.receiverEmail,
      },
      attachments: newReplyAttachmentList,
    };
    // const replyMessage = {tweet: message, id: new Date().toString(), name: 'Agent'}
    dispatch(
      updateTwitterAgentReply({
        interactionId: activeInteractionID,
        replyMessage,
      })
    );
  };

  /**
   * function  to render Icon For Attachments
   * @param param0 - param
   * @example renderIconForAttachments()
   * @returns
   */
  function renderIconForAttachments(param: string) {
    const extension = param.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'png':
      case 'jpg':
      case 'bmp':
        return <CcfEmailJpgIcon className={styles.emailAttachmentIcon} />;
      case 'pdf':
        return <CcfEmailPdfIcon className={styles.emailAttachmentIcon} />;
      default:
        return '';
    }
  }

  /**
   * function  to remove attachment
   * @param param0 - param
   * @example attachmentRemoveHandler()
   * @returns
   */
  function attachmentRemoveHandler(attachmentItem: any) {
    const updatedAttachmentList = replyAttachmentList.filter(
      (attach: any) => attach.name !== attachmentItem
    );
    setreplyAttachmentList(updatedAttachmentList);
    fileUpload.current.value = '';
  }

  /**
   * function  for Attachment Progress bar
   * @param param0 - progressValue
   * @param param1 - attachmentId
   * @example progressCallback(30,1)
   * @returns
   */
  function progressCallback(progressValue: any, attachmentId: number) {
    setreplyAttachmentList(
      replyAttachmentList.map((attachment: any, index: number) => {
        if (index === attachmentId) {
          return { ...attachment, progress: progressValue };
        }
        return attachment;
      })
    );
    setreplyAttachmentList((state) => {
      return state;
    });
  }

  /**
   * Handles copilot actions.
   * @example copilotActionHandler()
   */
  const copilotActionHandler = (action: string) => {
    if (action === 'Copilot Search') {
      return setIsCopilotActionMenuOpen(false); //only close the modal when action is Copilot Search
    }
    const copilotResponses = {
      Simplify:
        "Thank you for contacting us, and I'm sorry for the trouble you had on your recent flight from Salt Lake City to Chicago. I know how frustrating these problems can be, and it's disappointing that we didn't meet your expectations for a smooth travel experience.",
      Expand:
        'I appreciate your communication with us, and I would like to extend my sincere apologies for any inconvenience you may have encountered during your recent journey from Salt Lake City to Chicago. I truly understand the frustration and disruption that such issues can cause. Our primary goal is to offer a travel experience.',
      Rephrase:
        'Thank you for contacting us, and I sincerely apologize for the inconvenience you encountered on your recent flight from Salt Lake City to Chicago. I understand how frustrating and disruptive these issues can be. Our goal is to provide a smooth and enjoyable travel experience, and it’s disappointing to hear that we didn’t meet your expectations.',
    };

    const copilotUpdatedText =
      copilotResponses[action as keyof typeof copilotResponses] || '';
    setCopilotActionUpdatedText(copilotUpdatedText);

    if (editorRef.current) {
      dispatch(
        setGeneratedEmailResponse([`Hi ${
            activecontact?.customer.firstName
          },`, copilotUpdatedText,
          'To address the issue with your damaged luggage, complete the steps below:', 
          `${
            isWebLinkInserted
              ? '1. Obtain a reference number here: <a href="https://www.delta.com/referencenumber" target="_blank">Obtaining a reference number.</a>'
              : '1. Enter this reference number into your claim - GHY38R'
          }`,
          '2. Take pictures of the damaged luggage and keep them as evidence.',
          '3. Fill out the damaged luggage claim form linked here and provide the flight number, date of travel and a description of the damage.',
          '4. Attach pictures to the claim form.',
          '5. Keep a copy for your records, Delta will get back in 7-10 business days.',
          'Thanks for your patience,', 
          'Delta Customer Service'
        ]));
      
      
    }

    setEmailSendButton(true);
    setIsCopilotActionMenuOpen(false); // Close modal after action
  };

  
  /**
   * @example handleTextSelection()
   */
  const handleTextSelection = () => {
    const selection = window.getSelection()?.toString() || '';
    if (selection) {
      setSelectedText(selection);
    }
  };

  /**
   * function  for displaying copilot actions popover
   * @example CopilotActions()
   * @returns
   */
  const CopilotActions = ({
    isOpen,
    onClose,
    onCopilotAction,
    anchorEl,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onCopilotAction: (action: string) => void;
    anchorEl: HTMLElement | null; // Required for positioning the popover
  }) => {
    const boxStyle = {
      width: '157px',
      padding: '4px 0px',
      opacity: 1,
      background: '#FFFFFF',
      border: '1px solid #00000029',
      boxShadow: '0px 4px 12px 0px #00000014',
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    };

    const buttonStyle = {
      width: '100%',
      height: '36px',
      padding: '4px 4px 4px 16px',
      gap: '8px',
      opacity: 1,
      textAlign: 'left',
      justifyContent: 'flex-start',
      color: '#333333',
    };

    return (
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={boxStyle}>
          {['Simplify', 'Expand', 'Rephrase', 'Copilot Search'].map(
            (action) => (
              <Button
                key={action}
                onClick={() => onCopilotAction(action)}
                sx={buttonStyle}
              >
                {action}
              </Button>
            )
          )}
        </Box>
      </Popover>
    );
  };

  /**
   * function  for handling copilot action icon click
   * @example handleCopilotIconClick()
   */
  const handleCopilotIconClick = () => {
    const copilotActionButton = document.getElementById(
      'copilot-action-button'
    );
    setAnchorEl(copilotActionButton);
    setIsCopilotActionMenuOpen(!isCopilotActionMenuOpen);
  };

  return (
    <div className={styles.emailBoxContainer}>
      <div className={styles.emailBoxBody}>
        <CcfBox className={styles.emailFieldContainer}>
          <CcfTypography
            className={styles.emailFieldLabel}
            translationKey={'to'}
          />
          <input
            type="text"
            // value={emailValue}
            ref={toInputref}
            value={activecontact?.customer.emailId}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              setEmailValue(e.target.value);
            }}
            className={styles.emailInputField}
          ></input>
          {!showCc && (
            <CcfTypography
              className={styles.emailFieldLabel}
              style={{ marginRight: '5px' }}
              onClick={displayCc}
              translationKey={'cc'}
            />
          )}
          {!showBcc && (
            <CcfTypography
              className={styles.emailFieldLabel}
              onClick={displayBcc}
              translationKey={'bcc'}
            />
          )}
        </CcfBox>
        {showCc && (
          <CcfBox className={styles.emailFieldContainer}>
            <CcfTypography
              className={styles.emailFieldLabel}
              translationKey={'cc'}
            />
            <input
              type="text"
              className={styles.emailInputField}
              value={emailCcValue}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                setEmailCcValue(e.target.value);
              }}
            ></input>
            <button
              type="button"
              className={styles.closeButton}
              onClick={hideCcHandler}
            >
              &times;
            </button>
          </CcfBox>
        )}
        {showBcc && (
          <CcfBox className={styles.emailFieldContainer}>
            <CcfTypography
              className={styles.emailFieldLabel}
              translationKey={'bcc'}
            />
            <input
              type="text"
              className={styles.emailInputField}
              value={emailBccValue}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                setEmailBccValue(e.target.value);
              }}
            ></input>
            <button
              type="button"
              className={styles.closeButton}
              onClick={hideBccHandler}
            >
              &times;
            </button>
          </CcfBox>
        )}
        <CcfBox className={styles.emailFieldContainer}>
          <CcfTypography
            className={styles.emailFieldLabel}
            translationKey={'from'}
          />
          <input
            type="text"
            ref={fromInputref}
            value={activecontact?.receiverEmail}
            className={styles.emailInputField}
          ></input>
        </CcfBox>
        <CcfBox
          className={styles.emailFieldContainer}
          style={{ marginBottom: '0px' }}
        >
          <CcfTypography
            className={styles.emailFieldLabel}
            translationKey={'subject'}
          />

          <input
            type="text"
            value={emailSubject}
            className={styles.emailInputField}
          ></input>
        </CcfBox>
        <CcfBox>
          <LexicalComposer
            initialConfig={{
              namespace: 'CcfEmailEditor',
              theme: editorTheme,
              nodes: [ListNode, ListItemNode, LinkNode, TableCellNode, TableNode, TableRowNode, InlineImageNode],
              onError: (error: Error) => console.error(error),
            }}
          >
            <LexicalEditorContent
              generatedEmailResponse={activecontact?.copilotAssist === 'No' && quickReply === '' ? []  : generatedEmailResponse}
              setEmailSendButton={setEmailSendButton}
              editorRef={editorRef}
              handleTextSelection={handleTextSelection}
              dispatch={dispatch}
              fileUpload={fileUpload}
              getFileInfo={getFileInfo}
            />
          </LexicalComposer>
          {isCopilotActionMenuOpen && (
            <CopilotActions
              isOpen={isCopilotActionMenuOpen}
              onClose={() => setIsCopilotActionMenuOpen(false)}
              onCopilotAction={copilotActionHandler}
              anchorEl={anchorEl}
            />
          )}
          <TransitionGroup>
            {replyAttachmentList.length > 0 &&
              replyAttachmentList.map((attachmentItem: any, index: number) => {
                return (
                  <Slide key={index} direction={'left'} timeout={500}>
                    <div
                      className={styles.attachmentBox}
                      style={{
                        width: attachmentItem.progress === 100 ? '50%' : '100%',
                      }}
                      key={index}
                    >
                      <CcfTypography
                        className={
                          attachmentItem.progress === 100
                            ? styles.fileNameInBlue
                            : styles.fileNameInBlack
                        }
                        style={{
                          width:
                            attachmentItem.progress === 100 ? '100%' : '65%',
                        }}
                      >
                        {renderIconForAttachments(attachmentItem.name)} &nbsp;{' '}
                        {attachmentItem.name} &nbsp; (372K)
                      </CcfTypography>
                      <CcfEmailProgressBar
                        attachmentId={index}
                        progressCallback={progressCallback}
                      />
                      <CcfCloseIcon
                        className={styles.attachmentCloseIcon}
                        onClick={() => {
                          attachmentRemoveHandler(attachmentItem.name);
                        }}
                      />
                    </div>
                  </Slide>
                );
              })}
          </TransitionGroup>
        </CcfBox>
      </div>
      <div className={styles.emailBoxFooter}>
        <div className={styles.emailSendButtonContainer}>
          {activecontact?.copilotAssist === 'Yes' &&  (
            <CcfButton className={styles.buttonClass} id="copilot-action-button">
            <CcfCopilotSuggestionIcon
              style={{ fontSize: '18px' }}
              onClick={handleCopilotIconClick}
            />
          </CcfButton>
          )}
          <CcfButton className={styles.buttonClass}>
            + {translate('add_note')}
          </CcfButton>
          <CcfButton className={styles.buttonClass} onClick={openQuickReply}>
            <CcfFlashIcon />
            {translate('replies')}
          </CcfButton>
          <CcfButton
            className={styles.buttonClass}
            onClick={closeEmailReplyHandler}
          >
            {translate('cancel')}
          </CcfButton>
          {activecontact?.customer?.replywithApproval === 'No' && (
            <CcfButton
              primary
              onClick={emailReplyHandler}
              variant="contained"
              color="primary"
              style={{ marginLeft: '5px' }}
              className={styles.sendButton}
              disabled={!EmailSendButton}
            >
              <Send />
            </CcfButton>
          )}
          {activecontact?.customer?.replywithApproval === 'Yes' && (
            <CcfButton
              primary
              onClick={emailReplyHandler}
              variant="contained"
              color="primary"
              style={{ marginLeft: '5px' }}
              className={styles.sendButton}
              disabled={!EmailSendButton}
            >
              {translate('requestApproval')} &nbsp;{' '}
              <KeyboardArrowDown
                style={{
                  transform: replyWithApprovalBlock
                    ? 'rotate(180deg)'
                    : 'rotate(360deg)',
                }}
              />
              {replyWithApprovalBlock && renderRequestApprovalBlock()}
            </CcfButton>
          )}
        </div>
      </div>
    </div>
  );
}

export default CcfDigitalEmailTemplate;
